export const base_urls = {
    sfa_url: 'fmcgws/',
    hrws: 'hrws/',
    f_base: 'f-base/',
    f_auth: 'f-auth/',
    f_service_income: 'f-service-income/',
    f_sales: 'f-sales/',
    lovello_fridge: 'lovello-fridge/',
    f_party: 'f-party/',
    asset: 'asset/',
};
